import React from 'react'
import smartphone from "../img/smartphone.png";
import sqsmartphone from "../img/sqsmartphone.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

import hconnect from "../img/hconnect.png";
import sqhconnect from "../img/sqhconnect.png";

import keyboard from "../img/keyboard.png";
import sqkeyboard from "../img/sqkeyboard.png";


/*
<LazyLoadImage
                alt="paypal"
                effect="blur"
                src={paypal}
                placeholderSrc={sqpaypal}
                width="40px"
                height="40px"
              />
*/
import './Connect.css'
function Connect() {
    function handleConnect() {
        const connectUs = document.querySelector(".home-connect-m");
        connectUs.classList.toggle("hide");
      }
    
  return (
    <div className="home-connect-c">
    <div className="home-connect-m hide">
      <div className="hc1">
        <a href="mailto:contact@qodeit.com">
          Email
          <LazyLoadImage
                alt="Email"
                effect="blur"
                src={keyboard}
                placeholderSrc={sqkeyboard}
                width="50px"
                height="50px"
              />
        </a>
      </div>
      <div className="hc1">
        <a href="https://wa.me/919424229851" target="blank">
          Chat
          <LazyLoadImage
                alt="Whatsapp"
                effect="blur"
                src={smartphone}
                placeholderSrc={sqsmartphone}
                width="50px"
                height="50px"
              />
        </a>
      </div>
    </div>
    <LazyLoadImage
    onClick={handleConnect}
    id='connect-img'
                alt="connect to us"
                effect="blur"
                src={hconnect}
                placeholderSrc={sqhconnect}
                width="80px"
                height="80px"
              />
  </div>
  )
}

export default Connect